import { EnvironmentProviders, makeEnvironmentProviders, Type } from '@angular/core';

import { LightsImageProvider } from './lights-image.provider';

/**
 * Provide custom implementation of `LightsImageProvider`.
 */
/* istanbul ignore next */
export function provideLightsImageProvider(provider: Type<LightsImageProvider>): EnvironmentProviders {
	return makeEnvironmentProviders([{ provide: LightsImageProvider, useClass: provider }]);
}
